import { render, staticRenderFns } from "./TypeoperationsNews.vue?vue&type=template&id=4fb328a1&"
import script from "./TypeoperationsNews.vue?vue&type=script&lang=js&"
export * from "./TypeoperationsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports